(() => {
  'use strict';
  if (window.AlbumTagsBooking) {
    window.AlbumTagsBooking.initialize();
    return;
  }

  const selector = '[data-booking-disclosure]';
  const destinations = new Set(['#booking', '#StudioCallForm', '#AlbumTagsCallForm']);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const find = () => document.querySelector(selector);

  function open(disclosure, focus = false) {
    if (!disclosure) return;
    disclosure.open = true;
    if (!focus) return;
    window.requestAnimationFrame(() => {
      const panel = disclosure.querySelector('#StudioCallForm');
      if (!panel) return;
      panel.focus({ preventScroll: true });
      panel.scrollIntoView({
        block: 'start',
        behavior: reducedMotion.matches || document.body.dataset.motionEnabled === 'false' ? 'auto' : 'smooth',
      });
    });
  }

  function close(disclosure) {
    if (!disclosure) return;
    disclosure.open = false;
    disclosure.querySelector('summary')?.focus();
  }

  function initialize(scope = document) {
    const disclosures = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) disclosures.unshift(scope);
    disclosures.forEach(disclosure => {
      disclosure.dataset.bookingEnhanced = 'true';
      if (disclosure.querySelector('[data-booking-feedback]')) open(disclosure);
    });
    if (destinations.has(window.location.hash)) open(find());
  }

  document.addEventListener('click', event => {
    const closeButton = event.target.closest?.('[data-booking-close]');
    if (closeButton) {
      close(closeButton.closest(selector));
      return;
    }
    const link = event.target.closest?.('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !destinations.has(url.hash)) return;
    const disclosure = find();
    if (!disclosure) return;
    event.preventDefault();
    if (window.location.hash !== url.hash) window.history.pushState(null, '', url.hash);
    open(disclosure, true);
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const disclosure = event.target.closest?.(selector);
    if (!disclosure?.open) return;
    event.preventDefault();
    close(disclosure);
  });

  window.addEventListener('hashchange', () => {
    if (destinations.has(window.location.hash)) open(find(), true);
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:select', event => {
    const disclosure = event.target.querySelector?.(selector);
    if (disclosure) open(disclosure);
  });
  window.AlbumTagsBooking = { initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();
